module.exports = __webpack_public_path__ + "product-beans-medium.616a0dd7.jpg";